module.exports = __webpack_public_path__ + "img/santiagodechileebus_background_hero.0d5b26fa.png";